//Public routes are to be declared with prefix PUBLIC_
export const API_ROUTES = {
  MONDAY_GET_ITEM_DETAILS: 'monday/item-details/:itemId',
  MONDAY_ITEM_BOARD_HIERARCHY: 'monday/item-board-hierarchy/:itemId',
  MONDAY_GET_BOARD_FIRST_ITEM: 'monday/board-first-item/:boardId',
  MONDAY_GET_SUB_ITEMS: 'monday/item-with-subitems/:itemId',
  MONDAY_GET_SUBITEM_BOARD_PARENT: 'monday/subitem-board-parent/:subitemBoardId',
  MONDAY_GET_BOARD_ITEM_WITH_NONEMPTY_COLUMN:
    'monday/board-item-with-nonempty-column/:boardId',
  MONDAY_GET_BATCHED_SUBITEM_FORMULA:
    'monday/batch-hydrate-formula-columns/:itemId',
  MONDAY_GET_BATCHED_SUBITEM_DISPLAY_VALUES:
    'monday/batch-hydrate-subitem-display-values/:itemId',
  MONDAY_HYDRATE_LINKED_ITEM_FORMULAS:
    'monday/hydrate-formula-columns-for-items',

  GENERATE_PREVIEW: 'files/generate-preview',
  GET_FILE_DETAIL: 'files/find-or-create/with-rendered-string',
  GET_FILES_BY_ASSET_ID: 'files/by-asset-id/:assetId',
  GET_FILES_LIST: 'files?envelopeId=:envelopeId&itemId=:itemId',
  GET_WORD_DOCUMENT: 'files/:fileId/word-document',
  PATCH_FILE: 'files/:fileId',
  PREVIEW_WORD_EDITOR: 'files/preview-word-editor/:itemId/:fileId',
  FLATTEN_PDF_ACROFIELDS: 'files/flatten-pdf-acrofields',
  DETECT_PLACEHOLDERS_AI: 'files/detect-placeholders-ai',
  DETECT_PLACEHOLDERS_AI_STATUS: 'files/detect-placeholders-ai/status/:jobId',
  DETECT_PLACEHOLDERS_AI_RESULT: 'files/detect-placeholders-ai/result/:jobId',

  GET_ENVELOPE_DETAILS: 'envelope/find-one-by-id/:envelopeId',
  GET_ACCOUNT: 'account',

  // Update Envelope Config
  UPDATE_ENVELOPE_CONFIG: 'envelope/update-envelope-config/:envelopeId',
  UPDATE_STRIPE_CONFIGURATION:
    'envelope/update-envelope-config/:envelopeId/stripe-configuration',

  GET_SUBSCRIPTION_DETAILS: 'subscription',
  GET_ACTUAL_LINK: 'signing-flow/signing-link/:signingLinkId',
  CONNECT_STRIPE: 'stripe/connect',
  DISCONNECT_STRIPE: 'stripe/disconnect',
  GET_SIGNERS_SETTINGS: 'signing-flow/signer-data',
  GET_SIGNERS_DETAIL: 'signing-flow/signers-detail',
  GET_ENVELOPE_SIGNING_ORDER: 'signing-flow/envelope-signer-settings',

  // DATA FOR SIGNING FLOW SIGNER
  GET_DEFAULT_LANGUAGE:
    'signing-flow/default-language-for-signer/:fileHistoryId',
  GET_ACCOUNT_INFO_FOR_SIGNER:
    'signing-flow/account-info-for-signer/:fileHistoryId',

  // OTP Routes
  SEND_OTP: 'signing-flow/security/otp/send/:fileHistoryId',
  HAS_OTP_ENFORCED: 'signing-flow/security/otp/has-otp-enforced/:fileHistoryId',
  VERIFY_OTP: 'signing-flow/security/otp/verify/:fileHistoryId',
  EMAIL_VERIFICATION_OTP_ENABLED:
    'signing-flow/security/otp/has-email-verification-otp-enforced/:fileHistoryId',

  // Update Document Routes
  SAVE_SUPERDOC: 'files/:fileId/save-superdoc',
  SAVE_PDF_EDITOR: 'files/map-placeholders',
  MAP_BOARD_FIELDS: 'files/map-board-fields',
  MAP_TEMPLATE_BOARD_FIELDS: 'template-gallery/map-board-fields/:templateId',

  // Template Gallery Routes
  SAVE_SUPERDOC_TEMPLATE: 'template-gallery/save-superdoc-template',
  GENERATE_TEMPLATE_PREVIEW: 'template-gallery/:templateId/generate-preview',
  CONVERT_DOCUGEN_TEMPLATE: 'template-gallery/convert-docugen/:templateId',

  // Sign Documents Routes
  SIGN_DOCUMENTS: 'signing-flow/sign-documents',
  SIGNATURE_PROGRESS: 'signing-flow/actions/sign-status/:jobId',
  GET_FILES_FOR_SIGNER: 'signing-flow/files-for-signer/:fileHistoryId',
  CHECK_PAYMENT_MADE_FILE:
    'signing-flow/check-payment-status/:fileHistoryId/:fileDetailId',
  CHECK_PAYMENT_MADE_SIGNER:
    'signing-flow/check-payment-status-for-signer/:fileHistoryId',
  SIGNER_DOCUMENT_VIEWED: 'signing-flow/view-document/:itemId/:fileHistoryId',
  GET_ITEM_DETAILS_FOR_SIGNER:
    'signing-flow/item-details-for-signer/:fileHistoryId',
  DOWNLOAD_SIGNED_CONTRACT:
    'signing-flow/download-signed-contract/:fileHistoryId/:fileId',
  DOWNLOAD_CONTRACTS_PRIOR_SIGNING:
    'signing-flow/download-contracts-prior-signing/:fileHistoryId/:itemId',
  INITIATE_PAYMENT_WITH_STRIPE: 'signing-flow/initiate-payment-with-stripe',
  DECLINE_SIGNATURE: 'signing-flow/decline-signature',
  HAS_SIGNER_SIGNED: 'signing-flow/signer-signed/:envelopeId/:itemId',

  // File Field Routes
  FILE_FIELD_PRESIGNED_URL: 'signing-flow/file-field/presigned-url',
  FILE_FIELD_CONFIRM_UPLOAD: 'signing-flow/file-field/confirm-upload',
  FILE_FIELD_DELETE: 'signing-flow/file-field/delete',

  // Signature Image Upload Routes
  SIGNATURE_IMAGE_PRESIGNED_URL: 'signing-flow/signature-image/presigned-url',
  SIGNATURE_IMAGE_CONFIRM_UPLOAD: 'signing-flow/signature-image/confirm-upload',
  SIGNATURE_IMAGE_DELETE: 'signing-flow/signature-image/delete',

  // Template Routes
  GET_TEMPLATE_DETAILS: 'template-gallery/template-details/:templateId',
  GET_TEMPLATE_FILE_CONTENT:
    'template-gallery/:templateId/file-content/:fileId',
  SAVE_TEMPLATE: 'template-gallery/map-template-placeholder/:templateId',
  GET_SOURCE_BOARD_FIELDS: 'template-gallery/source-board-fields/:templateId',

  // Onboarding Routes
  GET_USER_ONBOARDING: 'onboarding/user-onboarding',
  UPDATE_USER_ONBOARDING: 'onboarding/update',

  // Form Routes
  GET_FORM_DETAIL: 'envelope/:envelopeId/form',
  GET_FORM_DETAIL_SIGNERS: 'signing-flow/form/:fileHistoryId',
  SAVE_FORM_DETAIL: 'envelope/:envelopeId/form',

  // File storage (e.g. logo upload)
  FILE_STORAGE_LOGO: 'file-storage/logo',
  FILE_STORAGE_LOGO_PRESIGNED_URL: 'file-storage/logo/presigned-url',

  // Superadmin Routes
  SUPERADMIN_ME: 'superadmin/me',
  SUPERADMIN_ACCOUNTS: 'superadmin/accounts',
  SUPERADMIN_ACCOUNT_DETAIL: 'superadmin/accounts/:accountId',
  SUPERADMIN_ACCOUNT_BOARDS: 'superadmin/accounts/:accountId/boards',
  SUPERADMIN_BOARD_ENVELOPES:
    'superadmin/accounts/:accountId/boards/:boardId/envelopes',
  SUPERADMIN_BOARD_WEBHOOKS:
    'superadmin/accounts/:accountId/boards/:boardId/webhooks',
  SUPERADMIN_BOARD_WEBHOOK:
    'superadmin/accounts/:accountId/boards/:boardId/webhooks/:webhookId',
  SUPERADMIN_ACCOUNT_USAGE: 'superadmin/accounts/:accountId/usage',
};
